import { useMemo, useState } from "react";
import intl from "react-intl-universal";
import { PageHeaderWithBack } from "../../../Components/Molecules";
import { CrossborderCustomersFilterBar } from "./components/CrossborderCustomersFilterBar";
import { CrossborderCustomersTable } from "./components/CrossborderCustomersTable";
import { CROSSBORDER_HOME_PATH, MOCK_CUSTOMERS } from "./constants";
import {
  EMPTY_CUSTOMERS_FILTERS,
  filterCustomers,
} from "./crossborderCustomersFilters";

export const CrossborderCustomers = () => {
  const [filters, setFilters] = useState(EMPTY_CUSTOMERS_FILTERS);

  const filteredItems = useMemo(
    () => filterCustomers(MOCK_CUSTOMERS, filters),
    [filters]
  );

  return (
    <div className="w-full">
      <PageHeaderWithBack
        title={intl.get("crossborder.customers.title")}
        subTitle={intl.get("crossborder.customers.subtitle")}
        backTo={CROSSBORDER_HOME_PATH}
      />

      <section className="mb-4">
        <CrossborderCustomersFilterBar
          filters={filters}
          onFiltersChange={setFilters}
          filteredItems={filteredItems}
        />
      </section>

      <section>
        <h2 className="mb-3 text-sm font-bold text-brand-dark dark:text-gray-100">
          {intl.get("crossborder.customers.listTitle")}
        </h2>
        <CrossborderCustomersTable items={filteredItems} />
      </section>
    </div>
  );
};
